import Vue from 'vue'

const state = {
  resource: {},
  resourceList: [],
  index: 0,
  topicId:'',
  //试题数量
  exercisesCount:''
}

const actions = {
	// paramArr[0]:当前点击资源本身,paramArr[1]:页面全部资源List,paramArr[2]:当前点击资源在页面所有资源的索引位置
	playResource({commit}, paramArr){
		commit("PALY_RESOURCE", paramArr);
	},
  updateTopicId({commit}, topicId){
    commit("UPDATE_TOPIC_ID", topicId);
  },
  updateExercisesCount({commit}, count){
    commit("UPDATE_EXERCISES_COUNT", count);
  }
}

const mutations = {
  ["PALY_RESOURCE"](state, paramArr) {
    Vue.set(state, 'resource', paramArr[0]);        // paramArr[0]:当前点击资源本身
    if(paramArr.length > 1) {
      Vue.set(state, 'resourceList', paramArr[1]); // paramArr[1]:页面全部资源List
      Vue.set(state, 'index', paramArr[2]);        // paramArr[2]:当前点击资源在页面所有资源的索引位置
    }
  },
  ["UPDATE_TOPIC_ID"](state, topicId) {
    Vue.set(state, 'topicId', topicId);
  },
  ["UPDATE_EXERCISES_COUNT"](state, count) {
    Vue.set(state, 'exercisesCount', count);
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/showMessage.js